export class requisitionDisplaySelectedFilter {
    constructor() {
        this.searchString = "";
        this.clientOrBU = [],
            this.roleList = [],
            this.requisitionTypes = [],
            this.requisitionStates = [],
            this.requisitionNums = [],
            this.recruiters = [],
            this.jobTypes = [],
            this.workLocationIds = [],
            this.selectedFilterSort = "";
        this.showDisplayFilterIconFlag = true;
    }
}
;
//# sourceMappingURL=requisition-display-selected-filter.model.js.map